import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Output,
  OnDestroy,
  Input,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Address } from '@app/akita/api/addresses/models/address.model';
import { Product } from '@app/akita/api/products/models/product.model';
import { UserModel } from '@app/shared/models/api/user.model';
import { TranslocoModule } from '@ngneat/transloco';
import { Subject, Subscription } from 'rxjs';
import { MSClarityService } from '@app/shared/services/msclarity.service';
import { TamamOverviewComponent } from '../tamam-overview/tamam-overview.component';

export const TAMAM_SUPPORTED_COUNTRIES = ['SA']; // sa
export const TAMAM_SUPPORTED_CURRENCIES = ['SAR'];
export const TAMAM_MIN_AMOUNT = 3000;
export const TAMAM_MAX_AMOUNT = 30000;

@Component({
  standalone: true,
  selector: 'popsy-confirm-tamam-form',
  templateUrl: './confirm-tamam-form.template.html',
  styleUrls: ['./confirm-tamam-form.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    RouterModule,
    TranslocoModule,
    TamamOverviewComponent,
  ],
})
export class ConfirmTamamFormComponent implements OnDestroy {
  @Input() public mode?: 'FINANCING' | null;
  @Input() public productId?: string | null;
  @Input() public country?: string | null;
  @Input() public address?: Address | null;
  @Input() public email?: string | null;
  @Input() public amount?: number | null;
  @Input() public currency?: string | null;
  @Output() public readonly payment: EventEmitter<boolean | null>;

  public processingPayment?: boolean | null;
  public tamamInitialized: {
    lang: string;
    product: Product;
    user: UserModel;
    address: Address;
    email?: string | null;
  } | null;

  private readonly subscriptions: Subscription;
  private readonly destroySubject: Subject<void>;

  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private readonly msClarityService: MSClarityService
  ) {
    this.destroySubject = new Subject();
    this.subscriptions = new Subscription();
    this.payment = new EventEmitter();
    this.tamamInitialized = null;
  }

  public onPay(): void {
    this.msClarityService.setTag('payment-intent', 'TAMAM');
    this.msClarityService.upgradeSession('buy-with-tamam');

    this.processingPayment = true;
    this.changeDetector.markForCheck();
    this.payment.emit(true);
  }

  public ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();

    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
